import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { FaCheckCircle, FaAdjust, FaCode, FaTrophy } from "react-icons/fa";
import apiClient from "../../utils/apiClient";

const PracticeStatsBar = ({ studentId }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!studentId) return;
    const fetchStats = async () => {
      try {
        const { data } = await apiClient.get(`/practice/stats/${studentId}`);
        setStats(data);
      } catch {
        setStats(null);
      }
      setLoading(false);
    };
    fetchStats();
  }, [studentId]);

  if (loading) return <div className="text-center py-3"><Spinner size="sm" /></div>;
  if (!stats) return null;

  const cards = [
    { label: "Solved", value: stats.solved, icon: <FaCheckCircle />, cls: "solved" },
    { label: "Partial", value: stats.partial, icon: <FaAdjust />, cls: "partial" },
    { label: "Attempted", value: stats.attempted, icon: <FaCode />, cls: "attempted" },
    { label: "Total Attempts", value: stats.totalAttempts, icon: <FaTrophy />, cls: "total" },
  ];

  return (
    <div className="practice-stats-bar">
      {cards.map((c) => (
        <div key={c.label} className="practice-stat-card">
          <div className={`practice-stat-icon ${c.cls}`}>{c.icon}</div>
          <div>
            <div className="practice-stat-value">{c.value}</div>
            <div className="practice-stat-label">{c.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PracticeStatsBar;
